import { render, staticRenderFns } from "./OrderDetailsBackorderedItem.vue?vue&type=template&id=c0eaa692&"
import script from "./OrderDetailsBackorderedItem.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsBackorderedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports